import { ROW_COL_SPAN } from '@modules/dashboard/constants';
import { DashboardCell } from 'generated/graphql';

export function removeCellFromRow(
  rowCellItems: DashboardCell[],
  removedCellIdx: number,
) {
  const numTotalCells = rowCellItems.length - 1;

  rowCellItems.splice(removedCellIdx, 1);

  if (rowCellItems.length) {
    const equalSizeCellColSpan = ROW_COL_SPAN / numTotalCells;
    rowCellItems.forEach((item) => {
      item.columnSpan = equalSizeCellColSpan;
    });
  }
}
